const { instantiate } = require('as-bind');

export const UseWasm = async () => {
  const instance = instantiate(fetch('default.wasm'));
  return instance;
};
